export default [
  {
    path: "/users/config",
    name: "usersconfig",
    component: () =>
      import("@/views/pages/users/user_config/UserConfigPage.vue"),
    meta: {
      pageTitle: "使用者管理模組",
      breadcrumb: [
        {
          text: "使用者設定",
          active: true,
        },
      ],
      keepAlive: true, // 需要被缓存
    },
  },
  {
    path: "/users/group-permission",
    name: "group-permission",
    component: () =>
      import("@/views/pages/users/GroupPermission/GroupPermissionPage.vue"),
    meta: {
      pageTitle: "使用者管理模組",
      breadcrumb: [
        {
          text: "人員群組維護",
          active: true,
        },
      ],
      keepAlive: true, // 需要被缓存
    },
  },
  {
    path: "/users/group-config",
    name: "group-config",
    component: () =>
      import("@/views/pages/users/GroupConfig/GroupConfigPage.vue"),
    meta: {
      pageTitle: "使用者管理模組",
      breadcrumb: [
        {
          text: "群組維護",
          active: true,
        },
      ],
      keepAlive: true, // 需要被缓存
    },
  },
  {
    path: "/users/config-pub",
    name: "usersconfig-pub",
    component: () =>
      import("@/views/pages/users/user_config/UserConfigPage.vue"),
    meta: {
      pageTitle: "使用者管理模組",
      breadcrumb: [
        {
          text: "使用者設定",
          active: true,
        },
      ],
      keepAlive: true, // 需要被缓存
    },
    // beforeEnter: (to, from, next) => {
    //   console.log("to");
    //   /*
    //    todo check if to === from
    //    Warning!: location.reload()  completely destroy all vuejs stored states
    //    */
    //   if (
    //     to?.name != from?.name &&
    //     to?.name?.replaceAll("-pub", "") == from?.name
    //   ) {
    //     return to();
    //   }

    //   return next();
    // },
  },
  {
    path: "/users/group-permission-pub",
    name: "group-permission-pub",
    component: () =>
      import("@/views/pages/users/GroupPermission/GroupPermissionPage.vue"),
    meta: {
      pageTitle: "使用者管理模組",
      breadcrumb: [
        {
          text: "人員群組維護",
          active: true,
        },
      ],
      keepAlive: true, // 需要被缓存
    },
  },
  {
    path: "/users/group-config-pub",
    name: "group-config-pub",
    component: () =>
      import("@/views/pages/users/GroupConfig/GroupConfigPage.vue"),
    meta: {
      pageTitle: "使用者管理模組",
      breadcrumb: [
        {
          text: "群組維護",
          active: true,
        },
      ],
      keepAlive: true, // 需要被缓存
    },
  },
];
